// Main navigation triggers
$('.nav__trigger').click(function(e) {
  e.preventDefault();
  var nav = $('.nav__collapse');
  if (nav.is(':visible')) {
    $('.icon__hamburger ,.nav__wrapper , .nav, .nav__collapse').removeClass('js-nav-active');
    nav.slideUp(250);
  } else {
    $('.icon__hamburger ,.nav__wrapper , .nav, .nav__collapse').addClass('js-nav-active');
    nav.slideDown(250);
  }
});



// WEBPACK FOOTER //
// ./assets/js/features/nav.js